import { Grid2 as Grid, Stack, Card, ButtonProps } from "@mui/material";
import { ElementType } from "react";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { CONTRACT_PAYMENTS_PATH, CONTRACT_INVOICES_PATH } from "../../../../paths";
import { InvoicesTable } from "../../invoices/components/InvoicesTable";
import { StyledStack } from "../../pages/ContractDetailsPage";
import { PaymentsTable } from "../../payments/components/PaymentsTable";
import { ContractBlocksTable } from "../components/ContractBlocksTable";
import { ContractServiceChargeRates } from "../components/ContractServiceChargeRates";
import { ContractSummaryCard } from "../components/ContractSummaryCard";
import { useContractLinks } from "../hooks/useContractLinks";
import { ContractTerms } from "./ContractTerms";

export const BrokerContractDetails = () => {
  const navigate = useNavigate();

  const { contract, isPending } = useContractLinks();

  if (!contract) {
    return null;
  }

  const blocks = contract.blocks?.length ? (
    <ContractBlocksTable contract={contract} isLoading={isPending} />
  ) : null;

  return (
    <StyledStack>
      <Grid container spacing={3} sx={{ pb: 4 }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
          <Stack gap={3}>
            <ContractSummaryCard contract={contract} isLoading={isPending} open />
            <ContractServiceChargeRates contract={contract} />
            {blocks}
            <ContractTerms />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
          <Stack gap={3}>
            <Card>
              <PaymentsTable
                summary
                onRowDoubleClick={({ row }) =>
                  navigate(generatePath(CONTRACT_PAYMENTS_PATH, { id: contract.shared_uuid }), {
                    state: { selectedRow: row.shared_uuid },
                  })
                }
                slotProps={{
                  toolbar: {
                    title: "Payments",
                    slotProps: {
                      button: {
                        component: Link,
                        to: generatePath(CONTRACT_PAYMENTS_PATH, { id: contract.shared_uuid }),
                        title: "See all payments",
                      } as ButtonProps<ElementType>,
                    },
                  },
                }}
              />
            </Card>
            <Card>
              <InvoicesTable
                summary
                onRowDoubleClick={({ row }) =>
                  navigate(generatePath(CONTRACT_INVOICES_PATH, { id: contract.shared_uuid }), {
                    state: { selectedRow: row.shared_uuid },
                  })
                }
                slotProps={{
                  toolbar: {
                    title: "Invoices",
                    slotProps: {
                      button: {
                        component: Link,
                        to: generatePath(CONTRACT_INVOICES_PATH, { id: contract.shared_uuid }),
                        title: "See all invoices",
                      } as ButtonProps<ElementType>,
                    },
                  },
                }}
              />
            </Card>
          </Stack>
        </Grid>
      </Grid>
    </StyledStack>
  );
};
